<template>
  <v-layout wrap v-if="LMD">
    <v-flex xs12 style="padding:10px 0 10px 25px" 
      :style="{ 'color' : item.Color }">
      <h5 style="font-weight:400;">{{$t('dashboard.lastModification')}} :</h5>
      <h5 style="font-weight:300;">{{getDate(LMD)}}</h5>
      <h5 style="font-weight:300;">PDF : https://menu.dview.es/assets/menus/{{item.ID}}.pdf</h5>
    </v-flex>
    <!-- <v-flex xs3 style="padding:10px 15px 10px 0;text-align: right">
      <v-btn class="mx-2" fab dark small :color="item.BGColorSecundary.substring(0,7).concat('33')"
        :elevation="0"
        @click="onChangeEnterprise(item, false)"
      >
        <v-icon :color="item.BGColorSecundary">mdi-chart-timeline-variant</v-icon>
      </v-btn>
    </v-flex> -->
  </v-layout>  
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  import utils from '@/services/utils'
  import constants from '@/constants'
  export default {
    props: {
      data: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      item: null,
      LMD: null
    }),
    // computed: {
    //   ...mapState('app',['locale', 'enterpriseID']),
    //   // enterpriseID () {
    //   //   return utils.getActiveEnterpriseID(this)
    //   // },
    //   enterpriseColor () {
    //     return this.$store.state.app.enterpriseColor ? this.$store.state.app.enterpriseColor : 'dtouch'
    //   }
    // },
    watch: {
      data (v) {
        if (v) {
          this.getLMD(this.data.ID)
          this.item = v
        }
      }
    },
    mounted () {
      this.getLMD(this.data.ID)
      this.item = this.data
    },
    methods: {
      getDate (value) {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }
        if(value) return new Date(value).toLocaleDateString(this.locale, options)
        return ''
      },
      getLMD(id) {
        api.getItem('enterprises', true, `${id}/LMD`).then(response => {
          this.LMD = response.LMD
        })
      }
    }
  }
</script>

<style lang="postcss" scoped>
  .table-main {
    width: 100%;
  }
  .table-main td {
    vertical-align: top;
  }
  .table-main.body {
    width: auto;
  }
  .enterprises {
    width: 400px;
    padding: 0 5px 0px 20px;
  }
</style>

